import React from 'react';
import { Provider } from 'mobx-react';
import Header from './components/Header';
import HeaderState from './stores/HeaderState';

const MvcHeader = railsProps => {
  const headerState = new HeaderState(railsProps);

  return (
    <Provider headerState={headerState}>
      <Header />
    </Provider>
  );
};

export default MvcHeader;
